import { Amplify } from 'aws-amplify';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Suspense, StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './app';
import { store } from './redux/store';
import { CONFIG } from './config-global';
import outputs from '../amplify_outputs.json';
import ConfigureAmplifyClientSide from './ConfigureAmplify';

// ----------------------------------------------------------------------

Sentry.init({
  dsn: 'https://01f8bd0d7330aecbfd71ad7745ac739e@o4508329876127744.ingest.us.sentry.io/4508331023400960',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root'));

Amplify.configure(outputs);

root.render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={CONFIG.site.basePath}>
        <Suspense>
          <Provider store={store}>
            <ConfigureAmplifyClientSide />
            <App />
          </Provider>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);
